export default __webpack_public_path__ + "static/01-underline-how-977868a60d02452ed757a340786bbbbc.svg";